// eslint-disable-next-line import/prefer-default-export
export function createWorkletProcessorCode() {
  return `
    class AudioProcessor extends AudioWorkletProcessor {
      process(inputs) {
        const input = inputs[0];
        if (input.length > 0) {
          const floatData = input[0];
          const int16Data = new Int16Array(floatData.length);
          for (let i = 0; i < floatData.length; i++) {
            int16Data[i] = Math.max(-32768, Math.min(32767, floatData[i] * 32767));
          }
          this.port.postMessage(int16Data);
        }
        return true;
      }
    }
    registerProcessor('audio-processor', AudioProcessor);
  `;
}
